import { gql } from '@apollo/client';

import { EpisodeState } from 'components/SeriesAccordionItem';

import { AudioCourseStory } from '.';

/* we need to fetch the audio course stories one by one because our setup does not allow to fetch multiple audios that are of contentType series.
Instead of fetching them one by one, we are getting advantage of graphql aliases to do build one query with all the audios that belong to the course */
export const buildMultiStoryQuery = (storyIds: string[]) => {
  const aliasQueries = storyIds
    .map(
      (storyId, storyIndex) => `
    story${storyIndex + 1}: story(storyId: "${storyId}", returnCookies: true) {
      ...AudioCourseStory
    }
  `,
    )
    .join('\n');

  return gql`
    query GetMultipleStories {
      ${aliasQueries}
    }

    fragment AudioCourseStory on StoryInterface {
      actions
      alreadyListened
      contentType {
        slug
      }
      description
      durationInMinutes
      id
      title
      transcodedAudioUrl
      transcodedSampleUrl
    }
  `;
};

export const calculateEpisodeState = (
  currentStory: AudioCourseStory,
  activeStoryId?: string,
): EpisodeState => {
  if (
    activeStoryId === currentStory.id &&
    currentStory.alreadyListened === false
  ) {
    return 'Highlighted';
  }

  if (currentStory.alreadyListened === true) {
    return 'Seen';
  }

  return 'Unseen';
};

export const calculateTotalStoriesAudioLength = (
  stories: AudioCourseStory[],
): string => {
  const totalSeconds = stories.reduce((sum, story) => {
    const [minutesStr, secondsStr] = story.durationInMinutes.split(':');
    const minutes = parseInt(minutesStr, 10);
    const seconds = parseInt(secondsStr, 10);

    return sum + (minutes * 60 + seconds);
  }, 0);

  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  const pad = (num: number) => String(num).padStart(2, '0');

  if (hours > 0) {
    return `${hours}:${pad(minutes)}:${pad(seconds)}`;
  } else {
    return `${pad(minutes)}:${pad(seconds)}`;
  }
};
